import { createBrowserRouter, Navigate } from "react-router-dom";

import { createElement } from "react";
import AuthGuard from "./AuthGuard";
import routerPublic from './routerPublic.tsx'
import Error from "@/views/Error";
import NotFound from "@/views/NotFound";
import Login from "@/views/Login";

const router = createBrowserRouter([
  {
    path: '/', // 重定向到首页
    element: createElement(Navigate, { to: '/home', replace: true }),
  },
  {
    path: '/',
    element: createElement(AuthGuard),
    children: routerPublic,
    errorElement: createElement(Error)
  },
  {
    path: '/login',
    element: createElement(Login),
  },
  {
    path: '*',
    element: createElement(NotFound)
  }
])


export default router
